/* eslint-disable no-case-declarations */
/* eslint-disable default-param-last */
import { Reducer } from 'redux';
import produce from 'immer';
import { ParcelamentoTypes, ParcelamentoServicesState } from './types';

const INITIAL_STATE: ParcelamentoServicesState = {
  parcelamento: {
    total_maximo_parcelas: 0,
    valor_base: '',
    valor_adicional: 0,
    servicos: [],
    valor_negociacao: 0,
    valor_variacao_forma_pagamento: '',
    valor_final: 0,
    valor_parcela: '',
    parcelas: {},
  },
  requestParcelamento: {
    loading: false,
    loaded: false,
    error: false,
  },
};
const reducer: Reducer<ParcelamentoServicesState> = (state = INITIAL_STATE, { type, result }) => {
  return produce(state, (draft) => {
    switch (type) {
      case ParcelamentoTypes.GET_PARCELAMENTO_REQUEST:
        draft.requestParcelamento = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case ParcelamentoTypes.GET_PARCELAMENTO_SUCCESS:
        draft.parcelamento.total_maximo_parcelas = result?.data?.total_maximo_parcelas;
        draft.parcelamento.valor_base = result?.data?.valor_base;
        draft.parcelamento.valor_adicional = result?.data?.valor_adicional;
        draft.parcelamento.servicos = result?.data?.servicos;
        draft.parcelamento.valor_negociacao = result?.data?.valor_negociacao;
        draft.parcelamento.valor_variacao_forma_pagamento =
          result?.data?.valor_variacao_forma_pagamento;
        draft.parcelamento.valor_negociacao = result?.data?.valor_negociacao;
        draft.parcelamento.valor_variacao_forma_pagamento =
          result?.data?.valor_variacao_forma_pagamento;
        draft.parcelamento.valor_final = result?.data?.valor_final;
        draft.parcelamento.valor_parcela = result?.data?.valor_parcela;
        draft.parcelamento.parcelas = result?.data?.parcelas;
        draft.requestParcelamento = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case ParcelamentoTypes.GET_PARCELAMENTO_FAILURE:
        draft.requestParcelamento = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      default:
    }
  });
};
export default reducer;
